var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon8BlogCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.62 8c.2 0 .38.11.45.29l1.13 2.66c.15.37.47.62.87.67l3.98.43c.54.06.95.52.95 1.07v1.74a.6.6 0 0 1-.61.6H2.7a.71.71 0 0 1-.71-.7v-1.7c0-.53.36-.97.88-1.06l1.96-.35c.36-.06.67-.31.81-.66L6.76 8.3c.08-.19.25-.3.46-.3h7.4m0-2h-7.4c-1.03 0-1.93.61-2.31 1.56l-.92 2.21-1.47.26A3.05 3.05 0 0 0 0 13.05v1.7c0 1.5 1.22 2.72 2.71 2.72H21.4a2.62 2.62 0 0 0 2.6-2.61v-1.74a3.07 3.07 0 0 0-2.72-3.05l-3.45-.38-.92-2.18A2.48 2.48 0 0 0 14.62 6z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.46 15.8)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.97,
    cy: 0.97,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.11,
    cy: 0.97,
    r: 1
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggZD0iTTE0LjYyIDhjLjIgMCAuMzguMTEuNDUuMjlsMS4xMyAyLjY2Yy4xNS4zNy40Ny42Mi44Ny42N2wzLjk4LjQzYy41NC4wNi45NS41Mi45NSAxLjA3djEuNzRhLjYuNiAwIDAgMS0uNjEuNkgyLjdhLjcxLjcxIDAgMCAxLS43MS0uN3YtMS43YzAtLjUzLjM2LS45Ny44OC0xLjA2bDEuOTYtLjM1Yy4zNi0uMDYuNjctLjMxLjgxLS42Nkw2Ljc2IDguM2MuMDgtLjE5LjI1LS4zLjQ2LS4zaDcuNG0wLTJoLTcuNGMtMS4wMyAwLTEuOTMuNjEtMi4zMSAxLjU2bC0uOTIgMi4yMS0xLjQ3LjI2QTMuMDUgMy4wNSAwIDAgMCAwIDEzLjA1djEuN2MwIDEuNSAxLjIyIDIuNzIgMi43MSAyLjcySDIxLjRhMi42MiAyLjYyIDAgMCAwIDIuNi0yLjYxdi0xLjc0YTMuMDcgMy4wNyAwIDAgMC0yLjcyLTMuMDVsLTMuNDUtLjM4LS45Mi0yLjE4QTIuNDggMi40OCAwIDAgMCAxNC42MiA2eiIgZmlsbD0iIzAwMCIgLz4NCiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0LjQ2IDE1LjgpIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIj4NCiAgICAgIDxjaXJjbGUgY3g9Ii45NyIgY3k9Ii45NyIgcj0iMSIvPg0KICAgICAgPGNpcmNsZSBjeD0iMTQuMTEiIGN5PSIuOTciIHI9IjEiLz4NCiAgICA8L2c+DQogIDwvZz4NCjwvc3ZnPg0K";
export { SvgIcon8BlogCar as ReactComponent };